import Joi from 'joi';

import { SerializableObjectSchema } from '../../../../generic/serialization/serializable-object-schema';
import { OrgConfigOperatorSchema } from '../../type/org-config-operator/org-config-operator-schema';
import { OrgConfigSchema } from '../org-config/org-config-schema';

export class AnyOrgConfigSchema extends SerializableObjectSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly type = 'type';

  private static readonly SCHEMA_ID = 'anyOrgConfig';

  private static readonly computedSchema = Joi.alternatives()
    .try(new OrgConfigOperatorSchema().getJoiSchema())
    .id(AnyOrgConfigSchema.SCHEMA_ID);

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static GenericDefaults = class {
    public static readonly type = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  public static getSchemaId(): string {
    return `#${AnyOrgConfigSchema.SCHEMA_ID}`;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } | import('joi').AnySchema {
    return AnyOrgConfigSchema.computedSchema;
  }

  public getCollection(orgId: string) {
    return new OrgConfigSchema().getCollection(orgId);
  }

  public getCollectionName() {
    return new OrgConfigSchema().getCollectionName();
  }
}
